import axios from "axios";
import { jwtDecode } from "jwt-decode";

const languageLearningApi = axios.create({
  // baseURL: "http://localhost:5001/api",
  baseURL: "https://api.ankiverse.com/api/language-learning",
  // baseURL: "https://ecf9-130-245-192-1.ngrok-free.app/micro/api",
  withCredentials: true,
});

// Helper: Decode token and return its expiration time (in ms)
function getTokenExpiry(token) {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000; // JWT exp is in seconds; convert to ms
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
}

let refreshTimeout;

// Schedule a proactive token refresh before expiry
function scheduleRefresh() {
  const token = localStorage.getItem("accessToken");
  if (!token) return;

  const expiryTime = getTokenExpiry(token);
  if (!expiryTime) return;

  const now = Date.now();
  const timeUntilExpiry = expiryTime - now;
  const refreshDelay = timeUntilExpiry - 60000; // Refresh 1 minute before expiry

  if (refreshDelay <= 0) {
    refreshAccessToken();
  } else {
    if (refreshTimeout) clearTimeout(refreshTimeout);
    refreshTimeout = setTimeout(refreshAccessToken, refreshDelay);
  }
}

// Function to refresh the access token
async function refreshAccessToken() {
  try {
    const { data } = await axios.post(
      "http://localhost:5000/api/auth/refresh-token",
      {},
      { withCredentials: true }
    );
    localStorage.setItem("accessToken", data.accessToken);
    languageLearningApi.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
    scheduleRefresh(); // Reschedule refresh with new token
  } catch (err) {
    console.error("Proactive token refresh failed", err);
    localStorage.removeItem("accessToken");
    window.location.href = "/login";
  }
}

// Request interceptor: attach the access token to every request
languageLearningApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: if a 401 error occurs, attempt a token refresh once
languageLearningApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const { data } = await axios.post(
          "http://localhost:5000/api/auth/refresh-token",
          {},
          { withCredentials: true }
        );
        localStorage.setItem("accessToken", data.accessToken);
        languageLearningApi.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
        scheduleRefresh();
        return languageLearningApi(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        localStorage.removeItem("accessToken");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

// If an access token exists on load, schedule its refresh
if (localStorage.getItem("accessToken")) {
  scheduleRefresh();
}

export default languageLearningApi;
